//Home.js
import Navbar from "../components/MainNavbar";
import { useState, useEffect } from "react";
import axios from "axios";
import { TSongSheet } from "../types/SongSheet";
import { NavLink } from "react-router-dom";
import SongsNavbar from "../components/SongsNavBar";
import { GetSongSheets } from "../services/SongSheet";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBolt,
  faGuitar,
  faHourglassHalf,
  faLightbulb,
  faMusic,
  faTooth,
} from "@fortawesome/free-solid-svg-icons";

const SongsHome = () => {
  const [songs, SetSongs] = useState<TSongSheet[]>([]);

  useEffect(() => {
    GetSongSheets(
      (res: any) => {
        SetSongs(res.data.songSheets);
      },
      (err: any) => {
        toast.error(err);
      }
    );
  }, []);

  const getSongsForFolder = (folderName: string) => {
    // if (folderName = "") {
    //   return songs.filter((song)=> song.folder.con);
    // }
    return songs.filter((song) => song.folder == folderName);
  };

  const songIdeas = getSongsForFolder("ideas");
  const songsWIP = getSongsForFolder("wip");
  const songsReady = getSongsForFolder("ready");
  const songsOther = getSongsForFolder("");

  return (
    <div>
      <Navbar />
      <SongsNavbar />
      <div className="mainContainer">
        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faHourglassHalf} /> Work in Progress
          </h2>
          <ul>
            {songsWIP?.map((item) => (
              <li>
                <span>
                  {" "}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faLightbulb} /> Ideas
          </h2>
          <ul>
            {songIdeas?.map((item) => (
              <li>
                <span>
                  {" "}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faGuitar} /> Gig Ready
          </h2>
          <ul>
            {songsReady?.map((item) => (
              <li>
                <span>
                  {" "}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faMusic} /> Originals
          </h2>
          <ul>
            {songsReady?.map((item) => (
              <li>
                <span>
                  {" "}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faTooth} /> Other
          </h2>
          <ul>
            {songs?.map((item) => (
              <li>
                <span>
                  {" "}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SongsHome;
